import { useEffect, useState } from 'react';

function Home() {
    const [mostrarMensagem, setMostrarMensagem] = useState(false);
    const [mensagem, setMensagem] = useState();
    useEffect(() => {
        const empresaId = localStorage.getItem('empresaId');

        if (Number(empresaId) === 16) {
            setMostrarMensagem(true);
            setMensagem('Aviso: Vendas no Restaurante Panaderia 69.627.632/0001-86');

            // Opcional: Oculta a mensagem automaticamente após 5 segundos
            const timer = setTimeout(() => setMostrarMensagem(false), 30000);
            return () => clearTimeout(timer);
        }
    }, []);

    // Container centralizado que NÃO bloqueia cliques na tela
    const containerMensagemStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        pointerEvents: 'none', // IMPORTANTE: Faz os cliques do mouse "atravessarem" o elemento
    };

    // Estilo do texto (com fundo leve e sombra para não sumir no conteúdo da página)
    const textoStyle = {
        fontSize: '3.5rem', // Letras grandes
        fontWeight: 'black',
        color: '#ff4d4f', // Cor em destaque (ex: vermelho/alerta)
        textAlign: 'center',
        margin: 0,
        padding: '20px 40px',
        backgroundColor: 'rgba(255, 255, 255, 0.85)', // Fundo semi-transparente para leitura
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        textTransform: 'uppercase',
        letterSpacing: '1px',
    };

    return (
        <section style={{ position: 'relative', minHeight: '100vh' }}>
            {/* Mensagem Flutuante Não-Bloqueante */}
            {mostrarMensagem && mensagem && (
                <div style={containerMensagemStyle}>
                    <h2 style={textoStyle}>{mensagem}</h2>
                </div>
            )}

            {/* Conteúdo normal do seu sistema (o usuário conseguirá interagir com tudo aqui) */}
            <h1>Home</h1>
            {/* <p>O usuário pode continuar preenchendo campos, clicando em botões e trabalhando aqui normalmente...</p>
            <button onClick={() => alert('Botão clicável por trás da mensagem!')}>Teste de Clique</button> */}
        </section>
    );
}

export default Home;
